<template>
    <div class="d-flex flex-column align-center">
        <v-avatar :size="size" :style="avatarStyle" @click="$emit('click')" class="zoezi-user-avatar">
            <v-auto-img :src="user.imagekey || user.imageurl || $api.getAssetUrl('/assets/img/profile_avatar_man.jpg')" />
        </v-avatar>
        <div v-if="change && canChange" class="primary--text mt-1 z-clickable" @click="$emit('change')">{{$translate('Change image')}}</div>
    </div>
</template>

<script>
export default {
    name: 'zoezi-user-avatar',

    props: {
        size: {
            type: Number,
            default: 100
        },
        border: {
            type: Boolean,
            default: false
        },
        user: {
            type: Object,
            default: null
        },
        change: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        canChange() {
            return !!this.$store.state?.settings?.fields?.find(x => x.name == 'image' && x.changeable_by_member);
        },
        avatarStyle() {
            return this.border ? {border: '2px solid ' + this.$root.colorToHex('primary')} : {};
        }
    }
}
</script>
